<template>
  <CRow>
    <CCol col="6" lg="6">
      <CCard>
        <CCardBody>
          <form
          @submit.prevent="saveData"
          method="post"
          >
              <h3>
                Generate Report
              </h3>
              <div class="row">
                <div class="col">
                  <CSelect
                        label="Report Type" 
                        :value.sync="report.report_type_id"
                        :plain="true"
                        :options="sale_types"
                        placeholder="Select a report type"
                        required
                    >
                    </CSelect>
                </div>
              </div>
              <div class="row">
                <div class="col">
                    <CInput :label="$t('fields.date_init')" type="date" v-model="report.date_init" required></CInput>
                </div>
              </div>
              <div class="row">
                <div class="col">
                    <CInput :label="$t('fields.date_end')" type="date" v-model="report.date_end" required></CInput>
                </div>
              </div>
              <CButton color="success" type="submit">
                <CIcon :content="$options.reportIcon" /> Generate
                </CButton>
              <CButton color="primary" @click="goBack"><CIcon :content="$options.backIcon" /> {{ $t('button.back') }}</CButton>
          </form>
        </CCardBody>
      </CCard>
    </CCol>

    <!--
    <CCol col="12">
        <CRow>
            <CCol col="12" class="bg-warning py-3 text-center m-1 font-weight-bold border border-dark">
                <label>REPORTE</label>
            </CCol>
            <CCol col="12">
                <CRow>
                    <CCol md="8">
                        <CRow class="text-center m-1 font-weight-bold border border-dark">
                            <CCol class="bg-warning py-4 border border-dark">
                                <label>DELIVERY TYPE</label>
                            </CCol>
                            <CCol class="bg-info py-5 border border-dark">
                                <label>PENDIENTE</label>
                            </CCol>
                            <CCol class="bg-info py-5 border border-dark">
                                <label>CASH</label>
                            </CCol>
                            <CCol class="bg-info py-5 border border-dark">
                                <label>TARJETA</label>
                            </CCol>
                            <CCol class="bg-info py-5 border border-dark">
                                <label>CHEQUE</label>
                            </CCol>
                            <CCol class="bg-info py-4 border border-dark">
                                <label>NO CONTESTO</label>
                            </CCol>
                            <CCol class="bg-danger py-3 border border-dark">
                                <label>TOTAL CREDITS (PENDING PAYMENTS)</label>
                            </CCol>
                        </CRow>
                    </CCol>
                    <CCol lg="4">
                        <CRow class="text-center m-1 font-weight-bold border border-dark">
                            <CCol md="4" class="bg-warning py-4 border border-dark">
                                <label>QUANTITY DELIVERY TYPE</label>
                            </CCol>
                            <CCol lg="4" class="bg-warning py-5 border border-dark">
                                <label>TOTAL SOLD</label>
                            </CCol>
                            <CCol lg="4" class="bg-success py-4 border border-dark">
                                <label>TOTAL GENERAL</label>
                            </CCol>
                        </CRow>
                    </CCol>
                </CRow>
            </CCol>

            <CCol col="12">
                <CRow>
                    <CCol md="8">
                        <CRow class="text-center m-1 font-weight-bold border border-dark">
                            <CCol class="bg-warning border border-dark">
                                &nbsp;
                            </CCol>
                            <CCol class="border border-dark">
                                &nbsp;
                            </CCol>
                            <CCol class="border border-dark">
                                &nbsp;
                            </CCol>
                            <CCol class="border border-dark">
                                &nbsp;
                            </CCol>
                            <CCol class="border border-dark">
                                &nbsp;
                            </CCol>
                            <CCol class="border border-dark">
                                &nbsp;
                            </CCol>
                            <CCol class="border border-dark">
                                &nbsp;
                            </CCol>
                        </CRow>
                    </CCol>
                    <CCol lg="4">
                        <CRow class="text-center m-1 font-weight-bold border border-dark">
                            <CCol md="4" class="border border-dark">
                                &nbsp;
                            </CCol>
                            <CCol lg="4" class="border border-dark">
                                &nbsp;
                            </CCol>
                            <CCol lg="4" class="border border-dark">
                                &nbsp;
                            </CCol>
                        </CRow>
                    </CCol>
                </CRow>
            </CCol>

            <CCol col="12">
                <CRow>
                    <CCol md="8">
                        <CRow class="text-center m-1 font-weight-bold border border-dark bg-success">
                            <CCol class="border border-dark">
                                &nbsp;
                            </CCol>
                            <CCol class="border border-dark">
                                &nbsp;
                            </CCol>
                            <CCol class="border border-dark">
                                &nbsp;
                            </CCol>
                            <CCol class="border border-dark">
                                &nbsp;
                            </CCol>
                            <CCol class="border border-dark">
                                &nbsp;
                            </CCol>
                            <CCol class="border border-dark">
                                &nbsp;
                            </CCol>
                            <CCol class="border border-dark">
                                &nbsp;
                            </CCol>
                        </CRow>
                    </CCol>
                    <CCol lg="4">
                        <CRow class="text-center m-1 font-weight-bold border border-dark bg-success">
                            <CCol md="4" class="border border-dark">
                                &nbsp;
                            </CCol>
                            <CCol lg="4" class="border border-dark">
                                &nbsp;
                            </CCol>
                            <CCol lg="4" class="border border-dark">
                                &nbsp;
                            </CCol>
                        </CRow>
                    </CCol>
                </CRow>
            </CCol>

            <CCol col="12" class="bg-warning py-3 text-center m-1 font-weight-bold border border-dark">
                <label>OTHERS</label>
            </CCol>

            <CCol col="12">
                <CRow>
                    <CCol md="4">
                        <CCol col="12" class="bg-danger py-1 text-center m-1 font-weight-bold border border-dark">
                            <label>EXPENSES</label>
                        </CCol>
                        <CRow class="text-center m-1 font-weight-bold border border-dark">
                            <CCol class="bg-danger py-1 border border-dark">
                                <label>EXPENSES TYPE</label>
                            </CCol>
                            <CCol class="bg-danger py-1 border border-dark">
                                <label>AMOUNT</label>
                            </CCol>
                        </CRow>
                    </CCol>
                    <CCol :md="{ offset:'4', size: '4' }">
                        <CCol col="12" class="bg-danger py-1 text-center m-1 font-weight-bold border border-dark">
                            <label>TOTALES GENERALES Y GANANCIA NETO</label>
                        </CCol>
                        <CRow class="text-center m-1 font-weight-bold border border-dark">
                            <CCol class="bg-danger py-1 border border-dark">
                                <label>NAMES</label>
                            </CCol>
                            <CCol class="bg-danger py-1 border border-dark">
                                <label>QUANTITY</label>
                            </CCol>
                        </CRow>
                    </CCol>
                </CRow>
            </CCol>

            <CCol col="12">
                <CRow>
                    <CCol md="4">
                        <CRow class="text-center m-1 font-weight-bold border border-dark">
                            <CCol class="border border-dark">
                                <label>EXPENSES TYPE</label>
                            </CCol>
                            <CCol class="border border-dark">
                                <label>AMOUNT</label>
                            </CCol>
                        </CRow>
                    </CCol>
                    <CCol :md="{ offset:'4', size: '4' }">
                        <CRow class="text-center m-1 font-weight-bold border border-dark">
                            <CCol class="border border-dark">
                                <label>NAMES</label>
                            </CCol>
                            <CCol class="border border-dark">
                                <label>QUANTITY</label>
                            </CCol>
                        </CRow>
                    </CCol>
                </CRow>
                <CRow>
                    <CCol md="4">
                        <CRow class="text-center m-1 font-weight-bold border border-dark">
                            <CCol class="border border-dark">
                                <label>TOTAL</label>
                            </CCol>
                            <CCol class="border border-dark">
                                <label>&nbsp;</label>
                            </CCol>
                        </CRow>
                    </CCol>
                    <CCol :md="{ offset:'4', size: '4' }">
                        <CRow class="text-center m-1 font-weight-bold border border-dark">
                            <CCol class="border border-dark">
                                <label>TOTAL</label>
                            </CCol>
                            <CCol class="border border-dark">
                                <label>&nbsp;</label>
                            </CCol>
                        </CRow>
                    </CCol>
                </CRow>
            </CCol>
        </CRow>
    </CCol>
    -->
  </CRow>
</template>

<script>
import axios from 'axios';
import formMixin from "../../mixins/form";
import localeMixin from '../../mixins/locale'; // Order matters, mixin first then i18n.
import i18n from "../../i18n";
import { cilBarcode, cilPlus, cilArrowLeft } from '@coreui/icons';

export default {
  name: 'FormEmployee',
  mixins: [formMixin, localeMixin],
  addIcon: cilPlus,
  reportIcon: cilBarcode,
  backIcon: cilArrowLeft,
  data() {
    return {
        report: {
          report_type_id: '',
          date_init: '',
          date_end: '',
        },
        sale_types: [
          {
            label: "Regular",
            value: 2
          },
          {
            label: "Bodega",
            value: 1
          }
        ],
    }
  },
  methods: {
      showAlertError() {
          if (this.message != "") {
              this.$swal({
                  title: i18n.t('modal.title'),
                  text: this.message,
                  icon: 'warning',
                  showCancelButton: true,
                  cancelButtonColor: '#d33',
              });
          } else {
              this.$swal({
                  title: i18n.t('modal.title'),
                  text: i18n.t('modal.body'),
                  icon: 'warning',
                  showCancelButton: true,
                  cancelButtonColor: '#d33',
              });
          }
      },
    goBack() {
      this.$router.push({ name: 'Reports' });
    },
    showAlert(type) {
      let title = '';
      let body = '';
      let status = '';

      switch(type) {
        case 'add':
          title = i18n.t('employees.modal.created_label');
          body = i18n.t('employees.modal.created_body');
          status = 'success';
          break;
        case 'edit':
          title = i18n.t('employees.modal.updated_label');
          body = i18n.t('employees.modal.updated_body');
          status = 'success';
          break;
        case 'error':
          title = 'Error';
          body = 'There was an error processing you request';
          status = 'error';
          break;
      }

      this.$swal(
        title,
        body,
        status
      ).then(result => {
        this.goBack();
      });
    },
    saveData() {
        console.log("aoeu");
        const data = this.report;
        this.$emit("saved", data);
        let url = `/api/reports`;
        let sendRequest = null;

        url = url + '?token=' + localStorage.getItem("api_token");
        sendRequest = async() => {
            try {
                const response = await axios.post(url, data);
                if (response.data.success) {
                    this.message = 'Successfully created report.';
                    this.showAlert('add');
                }
            } catch (error) {
                if(error.response.data.message == 'The given data was invalid.'){
                    this.message = '';
                    for (let key in error.response.data.errors) {
                        if (error.response.data.errors.hasOwnProperty(key)) {
                            this.message += error.response.data.errors[key][0] + '  ';
                        }
                    }
                    this.showAlert('error');
                } else{
                    console.log(error);
                    this.showAlertError(); 
                }
            }
        };

        sendRequest();
    },
  }
}

</script>
